import { ref } from 'vue';

export function useHoldable(
  onClick: (e: MouseEvent | TouchEvent) => void,
  onHold: (e: MouseEvent | TouchEvent) => void,
  holdDuration: number = 800,
) {
  const longPressTriggered = ref(false);
  const clickStarted = ref(false);
  let debugToggleTimer: ReturnType<typeof setTimeout>;

  function start(e: MouseEvent | TouchEvent) {
    e.preventDefault();
    longPressTriggered.value = false;
    clickStarted.value = true;
    debugToggleTimer = setTimeout(() => {
      longPressTriggered.value = true;
      onHold(e);
    }, holdDuration);
  }

  function end(e: MouseEvent | TouchEvent) {
    clearTimeout(debugToggleTimer);
    if (!clickStarted.value && !longPressTriggered.value) return;
    clickStarted.value = false;
    if (!longPressTriggered.value) {
      onClick(e);
    }
  }

  function move() {
    clearTimeout(debugToggleTimer);
  }

  return {
    listeners: {
      onTouchstart: start,
      onMousedown: start,
      onTouchend: end,
      onMouseup: end,
      onMouseleave: end,
      onTouchmove: move,
      onMousemove: move,
    },
  };
}
